// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import DefaultLayout from '../layouts/reset.vue';
import store from '../store';

const Home = () => import('../views/home.vue');
const MarketList = () => import('../views/marketList.vue');
const FeatureDetail = () => import('../views/featureDetail.vue');
const aiIntro = () => import('../views/aiIntro.vue');
const policy = () => import('../views/policy.vue');
const tc = () => import('../views/t&c.vue');
const Login = () => import('../views/login.vue');
const WaitOpen = () => import('../views/waitOpen.vue');
const TestPage = () => import('../views/testPage.vue');
const NotFound = () => import('../views/notFound.vue');
const UserCenter = () => import('../views/userCenter.vue');

const Main = () => import('../views/bot/main.vue');
const Credentials = () => import('../views/bot/credentials.vue');
const CreateBot = () => import('../views/bot/create_bot.vue');
const Bot = () => import('../views/bot/bot.vue');
const BotDetail = () => import('../views/bot/bot_detail.vue');
const HotStrategies = () => import('../views/bot/hot_strategies.vue');
const GridStrike = () => import('../views/bot/bot_config/grid_strike.vue');
const StatementDownload = () => import('../views/bot/statement_download.vue');
const TradingHistory = () => import('../views/bot/trading_history.vue');

const BotManage = () => import('../views/admin/bot_manage.vue');
const LlmStatus = () => import('../views/admin/llm_status.vue');

const routes = [
    {
        path: '/',
        children: [
            { path: '', name: 'home', component: Home }
        ]
    },
    // {
    //     path: '/home',
    //     children: [
    //         { path: '', name: 'home', component: Home }
    //     ]
    // },
    {
        path: '/marketList',
        children: [
            { path: '', name: 'marketList', component: MarketList }
        ]
    },
    {
        path: '/featureDetail',
        children: [
            { path: '', name: 'featureDetail', component: FeatureDetail }
        ]
    },
    {
        path: '/aiIntro',
        children: [
            { path: '', name: 'aiIntro', component: aiIntro }
        ]
    },
    {
        path: '/policy',
        children: [
            { path: '', name: 'policy', component: policy }
        ]
    },
    {
        path: '/t&c',
        children: [
            { path: '', name: 't&c', component: tc }
        ]
    },
    {
        path: '/login',
        children: [
            { path: '', name: 'login', component: Login }
        ]
    },
    {
        path: '/wait',
        children: [
            { path: '', name: 'wait', component: WaitOpen }
        ]
    },
    {
        path: '/testPage',
        children: [
            { path: '', name: 'testPage', component: TestPage }
        ]
    },
    {
        path: '/user-center',
        name: 'userCenter',
        component: UserCenter,
        meta: { requiresAuth: true }
    },
    {
        path: '/quantbot',
        name: 'quantbot',
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'quantbot_main',
                component: CreateBot
            },
            {
                path: 'credentials',
                name: 'credentials',
                component: Credentials
            },
            {
                path: 'create_bot',
                name: 'create_bot',
                component: CreateBot
            },
            {
                path: 'bot',
                name: 'bot',
                component: Bot
            },
            {
                path: 'bot_details/:id',
                name: 'bot_detail',
                component: BotDetail
            },
            {
                path: 'hot_strategies',
                name: 'hot_strategies',
                component: HotStrategies
            },
            {
                path: 'grid_strike',
                name: 'grid_strike',
                component: GridStrike
            },
            {
                path: 'statement_download',
                name: 'statement_download',
                component: StatementDownload
            },
            {
                path: 'trading_history',
                name: 'trading_history',
                component: TradingHistory
            }
        ]
    },
    {
        path: '/web-admin',
        name: 'web-admin',
        children: [
            {
                path: '',
                name: 'admin_main',
                component: BotManage
            },
            {
                path: 'bot_manage',
                name: 'bot_manage',
                component: BotManage
            },
            {
                path: 'llm_status',
                name: 'llm_status',
                component: LlmStatus
            }]
    },
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition;
        return { top: 0 };
    }
});

// 导航守卫：检查登录状态
router.beforeEach((to, from, next) => {
    // 初始化登录状态（从本地存储恢复）
    store.dispatch('initAuth');

    // 检查路由是否需要登录验证（包括父路由的 meta）
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (requiresAuth && !store.getters.getLogin) {
        // 未登录但需要认证，阻止访问并跳转到首页
        // 延迟触发登录弹窗，等待首页组件挂载
        setTimeout(() => {
            store.commit('triggerLogin');
        }, 300);
        // 跳转到首页，阻止访问受保护页面
        return next({ name: 'home' });
    }
    next();
});

router.afterEach((to) => {
    // 检查当前路由路径是否以 /quantbot 开头
    const isQuantbot = to.path.startsWith('/quantbot');
    const isAdmin = to.path.startsWith('/web-admin');
    const isUserCenter = to.path.startsWith('/user-center');

    // 根据判断结果设置 body 背景色
    if (isQuantbot || isAdmin || isUserCenter) {
        document.body.style.backgroundColor = '#ffffff'; // 白色
    } else {
        document.body.style.backgroundColor = '#07101b'; // 黑色
    }
});

export default router;
